export enum QueryKeys {
  Organization = "organization",
  MyProducts = "myProducts",
  ActivatedSubscriptions = "activatedSubscriptions",
  Macros = "macros",
  HasTicketsToImport = "hasTicketsToImport",
  KnowledgeBaseIntroFlags = "knowledgeBaseIntroFlags",
}
